import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AccountingPeriodService } from '../../accounting-period/services/accounting-period.service';
import { OfficeequipmentService } from './officeequipment.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-officeequipment',
  templateUrl: './officeequipment.component.html',
  styleUrls: ['./officeequipment.component.scss']
})
export class OfficeequipmentComponent implements OnInit {
  officeequipmentform: FormGroup;
  APPeriodId: any; equipid: any; isJump: any;
  tangibleAssetsValidation: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formBuilder: FormBuilder, private equipservice: OfficeequipmentService, private accountingperiod: AccountingPeriodService, public commonService: CommonService, private router: Router, public sidenav: SideNavService) { }
  ngOnInit() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
      this.Createofficeequipment();
      this.Getequipment(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata();
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})

    if (localStorage.getItem("SubmitStatus") == "true")
      this.officeequipmentform.disable()
    this.clearfield();
  }

  Createofficeequipment() {
    this.officeequipmentform = this.formBuilder.group({
      APPeriodId: ['', []],
      MasterId : ['', []],
      OfficeEquipmentId: ['' ,[]],
      PropertyPlantEquipmentGrossCost_End: ['', []],
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_End: ['', []],
      PropertyPlantEquipment_Start: ['', []],
      PropertyPlantEquipment_End: ['', []],
      TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment: ['', []],
      DisposalsPropertyPlantEquipment: ['', []],
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start: ['', []],
      IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment: ['', []],
      DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment: ['', []],
      PropertyPlantEquipmentGrossCost_Start: ['', []],
      PropertyPlantEquipmentFreeøtextComment: ['', []],
      CreatedBy: ['', []]
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.officeequipmentform.reset()
      }
    })
  }

  Insertequipment() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.officeequipmentform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.officeequipmentform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    if (this.equipid) {
      this.officeequipmentform.controls['OfficeEquipmentId'].setValue(this.equipid)
    }
  const formdata = this.officeequipmentform.getRawValue()
    this.equipservice.insertequipment(formdata).subscribe((data) => {
      this.officeequipmentform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Office Equipment", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'officeequipment') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  Getequipment(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.equipservice.getequipment(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.officeequipmentform.patchValue(data);
        this.equipid = data.OfficeEquipmentId
      }
      this.commonService.getNotesData();
      this.commonService.gettotaltanagable()
      this.officeequipmentform.controls['PropertyPlantEquipmentGrossCost_End'].disable();
      this.officeequipmentform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_End'].disable();
      this.officeequipmentform.controls['PropertyPlantEquipment_Start'].disable();
      this.officeequipmentform.controls['PropertyPlantEquipment_End'].disable();
      this.officeequipmentform.controls['TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment'].disable();
      this.officeequipmentform.controls['DisposalsPropertyPlantEquipment'].disable();
      this.officeequipmentform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start'].disable();
      this.officeequipmentform.controls['IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.officeequipmentform.controls['DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.officeequipmentform.controls['PropertyPlantEquipmentGrossCost_Start'].disable();
      this.Costcaluculations();
      this.depreciation();
    })
  }

  getlastyeardata() {
    this.equipservice.getequipmentLY(this.APPeriodId).subscribe((data: any) => {
      debugger
      this.showBubbledata = data;
      this.officeequipmentform.controls['PropertyPlantEquipment_End'].setValue(data.PropertyPlantEquipment_End)

    })
  }

  save() {
    debugger;
    //if (this.validations()) {
    if (true) {
      this.Insertequipment();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }
  back() {
    this.officeequipmentform.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Office Equipment", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }
  Costcaluculations() {
    //const propertyPlantEquipmentGrossCost_End = +this.officeequipmentform.get("PropertyPlantEquipmentGrossCost_Start").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_End = +this.officeequipmentform.get("TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment").value;
    //const propertyPlantEquipment_Start = +this.officeequipmentform.get("DisposalsPropertyPlantEquipment").value;
    //const total = propertyPlantEquipmentGrossCost_End + accumulatedDepreciationImpairmentPropertyPlantEquipment_End;
    //this.officeequipmentform.get("PropertyPlantEquipmentGrossCost_End").setValue(total - propertyPlantEquipment_Start);
    //this.officeequipmentform.get("PropertyPlantEquipment_Start").setValue(this.officeequipmentform.get("PropertyPlantEquipmentGrossCost_End").value - this.officeequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }

  depreciation() {
    //const totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment = +this.officeequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start").value;
    //const disposalsPropertyPlantEquipment = +this.officeequipmentform.get("IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_Start = +this.officeequipmentform.get("DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const total = totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment + disposalsPropertyPlantEquipment;
    //this.officeequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").setValue(total - accumulatedDepreciationImpairmentPropertyPlantEquipment_Start);
    //this.officeequipmentform.get("PropertyPlantEquipment_Start").setValue(this.officeequipmentform.get("PropertyPlantEquipmentGrossCost_End").value - this.officeequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }

  validations() {
    debugger
    if (!this.commonService.MotorVehicles ) {
      if (+this.officeequipmentform.controls['PropertyPlantEquipment_Start'].value + (this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_Start + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_Start +
        this.commonService.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_Start) != (+this.commonService.tangibleAssetsValidation.BalanceSheet_CY )) {
        Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.EndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.StartYear + " both values must match. ", 'warning')
        return false
      }
      if (+this.officeequipmentform.controls['PropertyPlantEquipment_End'].value + (this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_End + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_End +
        this.commonService.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_End) != (+this.commonService.tangibleAssetsValidation.BalanceSheet_LY)) {
        Swal.fire("Andica Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.LastyearEndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.LastYear + " both values must match. ", 'warning')
        return false
      }
      else {return true}
    }
    else { return true}
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.officeequipmentform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }
}
